import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SolicitudCpeProductosViewModel, TwProductoCertificadoPrevioExViewModel } from './productosCpe.types';


@Injectable()
export class ProductosCpeService {

   
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {


    }

    getSolicitudProductosCpe(id: number): Observable<SolicitudCpeProductosViewModel> {
        return this.http
            .get<SolicitudCpeProductosViewModel>(this.baseUrl + 'api/exportacion/cpes/productoCpe/' + id).pipe();
    }

    getProductoCpe(id: number): Observable<TwProductoCertificadoPrevioExViewModel> {
        return this.http
            .get<TwProductoCertificadoPrevioExViewModel>(this.baseUrl + 'api/exportacion/cpes/productoCpe/productoCpe/' + id).pipe();
    }

    createProductoCpe(producto: TwProductoCertificadoPrevioExViewModel): Observable<any> {
        return this.http
            .post<TwProductoCertificadoPrevioExViewModel>(this.baseUrl + 'api/exportacion/cpes/productoCpe', producto).pipe();
    }

    editProductoCpe(producto: TwProductoCertificadoPrevioExViewModel): Observable<any> {
        return this.http
            .put<TwProductoCertificadoPrevioExViewModel>(this.baseUrl + 'api/exportacion/cpes/productoCpe', producto).pipe();
    }

    deleteProductoCpe(id: number): Observable<any> {
        return this.http
            .delete<TwProductoCertificadoPrevioExViewModel>(this.baseUrl + 'api/exportacion/cpes/productoCpe/' + id).pipe();
    }
   

    
}
